<template>
  <div id="login">
    <div class="login-background" ref="lottieBG"></div>

    <div class="login-title">
      <div class="login-title-lottie" ref="lottieTitle"></div>
      <div class="login-title-main">晋城市老年人应急呼叫平台</div>
      <div class="login-title-minor">WELCOME TO LOGIN</div>
    </div>

    <div class="ig-form">
      <div class="ig-form-lottie" ref="lottieForm"></div>
      <el-form
        class="ig-form-wrap"
        ref="loginForm"
        :model="form"
        :rules="rules"
      >
        <el-form-item prop="username">
          <el-input
            v-model.trim="form.username"
            type="text"
            name="username"
            autocomplete="on"
            placeholder="请输入账号"
            :maxlength="20"
            clearable
          >
            <img
              src="../assets/images/icon_account.png"
              alt="账号"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            name="password"
            autocomplete="on"
            placeholder="请输入密码"
            :maxlength="20"
            show-password
            clearable
            @keyup.enter.native="handleLogin"
          >
            <img
              src="../assets/images/icon_password.png"
              alt="密码"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            type="text"
            v-model="form.code"
            placeholder="请输入正确的验证码"
          >
            <!-- <template slot="prepend">验证码</template> -->
            <template slot="append">
              <div class="login-code" @click="refreshCode">
                <Identify :identifyCode="form.identifyCode"></Identify>
              </div>
            </template>
            <img
              src="../assets/images/icon_yzm.png"
              alt="验证码"
              slot="prepend"
            />
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="loading" @click.native.prevent="handleLogin"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="login-footer">
      <div class="login-footer-lottie" ref="lottieFooter"></div>
      <!-- <div class="login-footer-text">©️南京市浦口区人民政府永宁街道办事处 版权所有</div> -->
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import lottieBG from "@ast/resources/lottie-bg.json";
import lottieForm from "@ast/resources/lottie-form.json";
import lottieTitle from "@ast/resources/lottie-title.json";
import lottieFooter from "@ast/resources/lottie-footer.json";
import Identify from "@cpt/Modules/identify";
import { setToken } from '@/utils/auth'
import md5 from 'js-md5';

export default {
  name: "Login",
  components: {
    Identify,
  },
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: "",
        identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
        identifyCode: "",
        code: "",
      },
      rules: {
        username: [{ required: true, trigger: "blur", message: "请输入账号" }],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.initAnimation();
    // 初始化验证码
    this.form.identifyCode = "";
    this.makeCode(this.form.identifyCodes, 4);
  },
  methods: {
    // 重置验证码
    refreshCode() {
      this.form.identifyCode = "";
      this.makeCode(this.form.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.form.identifyCode +=
          this.form.identifyCodes[
            this.randomNum(0, this.form.identifyCodes.length)
          ];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    handleLogin() {
      if (
        this.form.code.toLowerCase() !== this.form.identifyCode.toLowerCase()
      ) {
        this.$message.error("请填写正确验证码");
        this.refreshCode();
        return;
      }
      // this.form.username = md5(this.form.username)
      this.form.password = md5(this.form.password)
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$api
            .LogIn(this.form)
            .then((data) => {
              if (data) {
                setToken("data")
                this.$router.push({ path: "/index" });
              }
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        } else {
          this.refreshCode();
          return false;
        }
      });
    },
    handleLogin1() {
      if (
        this.form.code.toLowerCase() !== this.form.identifyCode.toLowerCase()
      ) {
        this.$message.error("请填写正确验证码");
        this.refreshCode();
        return;
      }
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("login", this.form)
            .then(() => {
              this.$router.push({ path: "/index" });
              this.loading = false;
            })
            .catch(() => {
              this.refreshCode();
              this.loading = false;
            });
        } else {
          this.refreshCode();
          return false;
        }
      });
    },
    initAnimation() {
      lottie.loadAnimation({
        name: "lottieBG",
        renderer: "svg",
        autoplay: true,
        loop: true,
        container: this.$refs.lottieBG,
        animationData: JSON.parse(JSON.stringify(lottieBG)),
      });
      lottie.loadAnimation({
        name: "lottieTitle",
        renderer: "svg",
        autoplay: true,
        loop: true,
        container: this.$refs.lottieTitle,
        animationData: JSON.parse(JSON.stringify(lottieTitle)),
      });
      lottie.loadAnimation({
        name: "lottieForm",
        renderer: "svg",
        autoplay: true,
        loop: true,
        container: this.$refs.lottieForm,
        animationData: JSON.parse(JSON.stringify(lottieForm)),
      });
      lottie.loadAnimation({
        name: "lottieFooter",
        renderer: "svg",
        autoplay: true,
        loop: true,
        container: this.$refs.lottieFooter,
        animationData: JSON.parse(JSON.stringify(lottieFooter)),
      });
    },
  },
};
</script>

<style lang="scss">
#login {
  // display: flex;
  // align-items: center;
  // flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(../assets/images/bg_login.jpg) no-repeat center/100% 100%;

  .login-background {
    z-index: 80;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .login-title {
    z-index: 90;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 5vh;
    left: 50%;
    width: 1500px;
    height: 150px;
    margin-left: -750px;
    color: #c6ecff;
    letter-spacing: 5px;
    text-shadow: 0 0 10px #75bcff;

    &-lottie {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &-main {
      font-size: 40px;
      font-weight: 500;
      font-family: "FZ-ZZH";
    }

    &-minor {
      margin-top: 30px;
      color: #aee3ff;
      font-size: 20px;
    }
  }

  .ig-form {
    z-index: 100;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 100px 170px;
    transform: translate(-50%, -50%);

    &-lottie {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .el-form-item {
      width: 360px;
      margin-bottom: 0;

      + .el-form-item {
        margin-top: 40px;
      }

      &__content {
        line-height: 40px;
        font-size: 16px;
      }

      &__error {
        padding-top: 4px;
        font-size: 12px;
      }
    }

    .el-input {
      font-size: 16px;
      border: 1px solid #55bee5;

      &:focus-within {
        box-shadow: 0 0 10px #4ab4ff;
      }

      &-group__prepend {
        border: none;
        padding: 0 20px;
        background-color: transparent;
        & > img {
          margin-top: 4px;
        }
      }

      &__inner {
        height: 40px;
        padding: 0 20px;
        line-height: 40px;
        color: #fff;
        border: none;
        background-color: transparent;
        @include input-placeholder(16px, #2477b7);

        &:-internal-autofill-selected {
          -webkit-text-fill-color: #fff;
          box-shadow: 0 0 0 100px #003c73 inset;
          background-color: transparent !important;
        }
      }

      &__suffix {
        right: 0;
      }

      &__icon {
        width: 25px;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .el-button {
      width: 100%;
      height: 40px;
      padding: 0;
      margin-top: 10px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      border-radius: 0;
      border: 1px solid #55bee5;
      background-color: #1761a5;
      box-shadow: 0 0 20px #56c9ff inset;
      // background: linear-gradient(#11abea, #1a87e3 66%) !important;
    }
  }

  .login-footer {
    z-index: 90;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 1500px;
    height: 150px;
    padding-top: 80px;
    margin-left: -750px;

    &-lottie {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &-text {
      text-align: center;
      color: #26abf0;
      font-size: 12px;
    }
  }
}
</style>
